import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["buttonLocation", "buttonUse", "buttonSize", "buttonTextOverride", "onButtonClick"];
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'foundations-components/transitional/components/Link';
import { Button } from 'foundations-components/transitional/components/Button';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getHasSuperAdminScope } from '../../selectors/authSelectors';
import { getHasMaxForecastTypes } from '../../selectors/forecastSelectors';
import Links from '../../constants/Links';
import { MAX_FORECASTS } from 'ui-deal-management-components-lib/constants/ForecastType';
import { setIsCreateForecastTypeWizardOpen } from '../../actions/WizardActions';
import { useCallback } from 'react';
import { trackCreateForecastClick } from '../../utils/usageTracker';
import { CLICK_CREATE_FORECAST_HEADER, CLICK_CREATE_FORECAST_FILTER } from '../../constants/Events';
import { getReturnLink } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CreateForecastButton = _ref => {
  let {
      buttonLocation,
      buttonUse = 'secondary',
      buttonSize = 'small',
      buttonTextOverride,
      onButtonClick
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const dispatch = useDispatch();
  const hasSuperAdminScope = useSelector(getHasSuperAdminScope);
  const hasMaxForecasts = useSelector(getHasMaxForecastTypes);
  const createForecastsDisabled = !hasSuperAdminScope || hasMaxForecasts;
  const handleClickCreateForecast = useCallback(() => {
    if (onButtonClick) {
      onButtonClick();
    }
    if (buttonLocation === 'header') {
      trackCreateForecastClick(CLICK_CREATE_FORECAST_HEADER);
    } else if (buttonLocation === 'filter') {
      trackCreateForecastClick(CLICK_CREATE_FORECAST_FILTER);
    } else if (buttonLocation === 'modal') {
      // already tracked in modal
    }
    dispatch(setIsCreateForecastTypeWizardOpen(true));
  }, [buttonLocation, dispatch, onButtonClick]);
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "bottom",
    disabled: !createForecastsDisabled,
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [!hasSuperAdminScope && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "index.header.actions.createForecastNotAdminTooltip"
      }), hasSuperAdminScope && hasMaxForecasts && /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "index.header.actions.createForecastMaxTooltip_jsx",
        options: {
          href: `${getReturnLink(window.location.pathname, window.location.search, Links.SETTINGS_MANAGE)}`,
          maxforecasts: MAX_FORECASTS
        },
        elements: {
          Link
        }
      })]
    }),
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      size: buttonSize,
      use: buttonUse,
      disabled: createForecastsDisabled,
      onClick: handleClickCreateForecast
    }, rest, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: buttonTextOverride || 'index.header.actions.createForecast'
      })
    }))
  });
};